import Vue from "vue";
import axios from "axios";
import store from "./store";

import { mapGetters } from "vuex";

import { Lang } from "laravel-vue-lang";
Vue.use(Lang, {
    fallback: "en"
});

var app = new Vue({
    store,
    el: "#navMenuMobile",
    components: {
    },
    data: {
    },
    mounted() {
        console.log("----------------------------------------navMenuMobile")
        this.$store.commit("setNavMenuId", this.getCookie("navMenuId"));

        // this.$refs[reftmp].$el.classList.add('active')
        console.log(this.$refs)
        console.log("navMenuId: "+ this.navMenuId)
    },
    methods: {
        selectNavMobile: function (id) {
            //remettre a blanc l icon de base
            console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
            console.log("selectNav"+id);

            store.commit("setNavMenuId", id);
            this.setCookie(
                "navMenuId",
                id
            );
        },
        setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            // logger.log('pass')
        },
        getCookie: function(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(";");
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

    },
    computed: {

        ...mapGetters([
            "searchOverView",
            "navMenuId",
            "lessonId",]),


    },
});
